import { render, staticRenderFns } from "./DocumentGenerique.vue?vue&type=template&id=7ac94a05"
import script from "./DocumentGenerique.vue?vue&type=script&lang=ts"
export * from "./DocumentGenerique.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports